<template>
  <h1 :class="{ isPc: !isSp }" class="title">{{ titleText }}</h1>
</template>

<script>
export default {
  name: 'LoginPageTitle',
  props: {
    titleText: {
      type: String,
      required: true,
    },
  },
  computed: {
    isSp() {
      return this.$isSp;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.title {
  color: $color-text-primary;
  font-size: 18px;
  font-weight: $text-weight-bold;
  line-height: 1.3;

  &.isPc {
    font-size: 20px;
  }
}
</style>
